/**
 * Based on custom icon example:
 * https://atlassian.design/components/icon/custom-icon/examples
 */

import React from 'react';
import Icon from '@atlaskit/icon';
import type { CustomGlyphProps, IconProps } from '@atlaskit/icon/types';

const ZoomLogo = (props: CustomGlyphProps) => (
	<svg
		height="24"
		width="24"
		version="1.1"
		id="Layer_1"
		xmlns="http://www.w3.org/2000/svg"
		x="0px"
		y="0px"
		viewBox="0 0 516 240"
		enable-background="new 0 0 516 240"
		xmlSpace="preserve"
		data-testid={props['data-testid']}
	>
		<path
			id="Wordmark"
			fill="#0B5CFF"
			d="M155.9,158.8H93.3c-4.1,0-8.1-2.2-10-5.9c-2.2-4.3-1.4-9.4,2-12.7l43.6-43.6H97.6
	c-8.6,0-15.5-7-15.5-15.5h57.7c4.1,0,8.1,2.2,10,5.9c2.2,4.3,1.4,9.4-2,12.7l-43.6,43.6h36.1C148.9,143.3,155.9,150.3,155.9,158.8z
	 M403.7,80c-9,0-17,3.9-22.6,10.1c-5.6-6.2-13.6-10.1-22.6-10.1c-16.6,0-30.2,14.2-30.2,30.8v48c8.6,0,15.5-7,15.5-15.5v-32.6
	c0-8,6.2-14.8,14.2-15.1c8.4-0.3,15.3,6.4,15.3,14.7v33c0,8.6,7,15.5,15.5,15.5v-48.2c0-8,6.2-14.8,14.2-15.1
	c8.4-0.3,15.3,6.4,15.3,14.7v33c0,8.6,7,15.5,15.5,15.5v-48C433.9,94.2,420.3,80,403.7,80z M234.3,120c0,22.1-17.9,40-40,40
	s-40-17.9-40-40c0-22.1,17.9-40,40-40S234.3,97.9,234.3,120z M218.8,120c0-13.5-11-24.5-24.5-24.5c-13.5,0-24.5,11-24.5,24.5
	c0,13.5,11,24.5,24.5,24.5C207.8,144.5,218.8,133.5,218.8,120z M320.5,120c0,22.1-17.9,40-40,40s-40-17.9-40-40
	c0-22.1,17.9-40,40-40S320.5,97.9,320.5,120z M305,120c0-13.5-11-24.5-24.5-24.5s-24.5,11-24.5,24.5c0,13.5,11,24.5,24.5,24.5
	S305,133.5,305,120z"
		/>
	</svg>
);

const ZoomLogomark = (props: IconProps) => <Icon {...props} glyph={ZoomLogo} />;

export default ZoomLogomark;
